export async function login(email, password) {
  const res = await fetch("https://woh-crm.worldofheels.com.ua/v1/iam/auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    throw new Error(res.status);
  }

  const data = await res.json();
  console.log(data);

  return data;
}
